import ResourcePage from "@/components/ResourcePage";
import PageHeader from "@/components/PageHeader";
import { DOC_TYPES } from "@/lib/constants";
import { useEventOptions } from "@/hooks/useEventOptions";
import { API } from "@/lib/api";

const columns = [
  { key: "name", label: "Nama Dokumen", render: (r) => <span className="font-semibold text-[#1A1A1A]">{r.name}</span> },
  { key: "type", label: "Jenis", badge: false },
  { key: "file", label: "File", render: (r) => r.file ? <a href={`${API}/files/${r.file}/download?auth=${localStorage.getItem("primrose_token")}`} target="_blank" rel="noreferrer" className="text-burgundy underline text-xs">Unduh</a> : (r.url ? <a href={r.url} target="_blank" rel="noreferrer" className="text-burgundy underline text-xs">Link</a> : "-") },
  { key: "created_at", label: "Ditambahkan", date: true },
];

export default function Documents() {
  const { options } = useEventOptions();
  const fields = [
    { name: "name", label: "Nama Dokumen", required: true, full: true },
    { name: "type", label: "Jenis", type: "select", options: DOC_TYPES, default: "Other" },
    { name: "event_id", label: "Event Terkait", type: "select", options: [{ value: "", label: "— Umum —" }, ...options], full: true },
    { name: "file", label: "Upload File", type: "file", full: true },
    { name: "url", label: "atau URL / Link Dokumen", full: true },
  ];
  return (
    <ResourcePage
      resource="documents" title="Dokumen" writeLevel={2}
      columns={columns} fields={fields}
      PageHeaderComp={<PageHeader overline="Manajemen Dokumen" title="Documents" subtitle="Simpan kontrak, invoice, floor plan dan dokumen penting lainnya." />}
    />
  );
}
